/* eslint-disable */
import generateStoreSetters from '@/helpers/generateStoreSetters';
import { State, StateHome } from './state';

const state = new State();

const store = {
  namespaced: true,
  state,
  mutations: {
    ...generateStoreSetters(state),
    clearState: (stateHome: StateHome): void => {}
  },
  actions: {},
  modules: {},
  getters: {}
};

export { store as home };
